module.exports = __webpack_public_path__ + "static/media/icn_back.c7598d0b.svg";